import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PRISM_DIALOG_DATA,
	PrismBetaIndicatorComponent,
	PrismButtonComponent,
	PrismCheckboxComponent,
	PrismDialogComponent,
	PrismDialogRef,
	PrismIconComponent
} from '@shure/prism-angular-components';

import { InfoDialogData } from '../info-dialog.component';

@Component({
	selector: 'sh-info-dialog',
	templateUrl: './prism-info-dialog.component.html',
	styleUrls: ['./prism-info-dialog.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		TranslocoModule,
		PrismBetaIndicatorComponent,
		PrismButtonComponent,
		PrismCheckboxComponent,
		PrismDialogComponent,
		PrismIconComponent
	]
})
export class PrismInfoDialogComponent {
	public doNotShowDialog = false;

	constructor(
		private readonly dialogRef: PrismDialogRef<PrismInfoDialogComponent, boolean>,
		@Inject(PRISM_DIALOG_DATA) public readonly data: InfoDialogData
	) {}

	public toggleDoNotShowDialog(doNotShowDialog: boolean): void {
		this.doNotShowDialog = doNotShowDialog;
	}

	public close(): void {
		this.dialogRef.close(this.doNotShowDialog);
	}
}
